<template>
  <svg :viewBox="`${this.left} -${this.bottom} ${this.width} ${this.height}`">
    <g :style="`transform-origin: 50% -50%; transform: scale(${scale})`">
    <g :transform="`scale(1,-1) translate(0,${this.ship.particulars.B+this.margin})`">
      <path
        :d="`M ${scaleXZ(-5.0000092,11.887175)} L ${scaleXZ(1.9522594,10.615793)} C ${scaleXZ(3.0955943,10.419191)} ${scaleXZ(4.2227506,10.228148)} ${scaleXZ(5.4021991,9.7161603)} C ${scaleXZ(6.581648,9.2041736)} ${scaleXZ(7.8133857,8.3712437)} ${scaleXZ(7.5890291,7.4633976)} C ${scaleXZ(7.3646723,6.5555514)} ${scaleXZ(5.6842175,5.572789)} ${scaleXZ(5.338886,4.601073)} C ${scaleXZ(4.9935544,3.6293214)} ${scaleXZ(5.9833494,2.6686513)} ${scaleXZ(7.0237928,1.9481667)} C ${scaleXZ(8.0642325,1.2276467)} ${scaleXZ(9.1553172,0.74731166)} ${scaleXZ(10.295146,0.42789088)} C ${scaleXZ(11.434969,0.10847009)} ${scaleXZ(12.623538,-0.05000114)} ${scaleXZ(13.800043,-0.05000114)}`"
        id="path1624"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(66.613835,22.242751)} C ${scaleXZ(54.67746,22.242892)} ${scaleXZ(42.740731,22.189814)} ${scaleXZ(30.804709,22.248906)} C ${scaleXZ(18.868662,22.308065)} ${scaleXZ(6.9333157,22.479531)} ${scaleXZ(-5.0000092,22.76645)}`"
        id="path1626"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(186.68237,22.242751)} C ${scaleXZ(195.44778,22.244758)} ${scaleXZ(204.22358,22.050079)} ${scaleXZ(212.98607,22.275642)} C ${scaleXZ(216.53645,22.367063)} ${scaleXZ(220.08462,22.527474)} ${scaleXZ(223.61755,22.743867)}`"
        id="path1628"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(233,15.58041)} C ${scaleXZ(233,17.068006)} ${scaleXZ(235.18815,20.062461)} ${scaleXZ(239.56441,24.563774)}`"
        id="path1630"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(221.80061,-0.05000114)} C ${scaleXZ(230.49728,-0.05000114)} ${scaleXZ(233.89461,1.2113252)} ${scaleXZ(235.72861,2.8857528)} C ${scaleXZ(237.56263,4.5601451)} ${scaleXZ(237.83339,6.6476388)} ${scaleXZ(237.31918,7.9482997)} C ${scaleXZ(236.80497,9.248996)} ${scaleXZ(235.50575,9.7628945)} ${scaleXZ(234.55453,10.25548)} C ${scaleXZ(233.6033,10.74803)} ${scaleXZ(233,11.219195)} ${scaleXZ(232.99911,11.930545)}`"
        id="path1632"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(37.686894,37.091252)} L ${scaleXZ(37.00984,34.432859)} V ${scaleZ(22.227456)}`"
        id="path1634"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(239.56444,24.563774)} L ${scaleXZ(226.43979,23.972021)} L ${scaleXZ(223.56962,22.722979)}`"
        id="path1636"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(37.686894,37.091252)} H ${scaleX(25.61878)}`"
        id="path1640"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(-4.7000002,0.15070782)} H ${scaleX(1.5266001)}`"
        id="path1642"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(21.717388,28.801783)} H ${scaleX(8.405239)}`"
        id="path1644"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(1.5266001,0.15070782)} V ${scaleZ(6.2307492)} L ${scaleXZ(2.4242458,10.444824)}`"
        id="path1646"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(25.61878,34.432859)} H ${scaleX(21.717388)}`"
        id="path1648"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(-4.7000002,10.586478)} V ${scaleZ(0.15070782)}`"
        id="path1650"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(-5,13.9)} H ${scaleX(233)}`"
        id="path1652"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(8.405239,28.801783)} V ${scaleZ(22.492601)}`"
        id="path1654"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(21.717388,34.432859)} V ${scaleZ(28.801783)}`"
        id="path1656"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(25.61878,37.091252)} V ${scaleZ(34.432859)}`"
        id="path1658"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(-5,22.766489)} V ${scaleZ(13.899999)} V ${scaleZ(11.887175)}`"
        id="path1660"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(66.613835,22.242714)} H ${scaleX(186.68237)}`"
        id="path1662"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(-4.7000002,10.586478)} L ${scaleXZ(-5,11.887175)}`"
        id="path1664"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(233,13.899999)} V ${scaleZ(11.956355)}`"
        id="path1666"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(233,15.580376)} V ${scaleZ(13.9)}`"
        id="path1668"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXZ(13.800052,-0.05000114)} H ${scaleX(221.80065)}`"
        id="path1670"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
    </g>

    <g :transform="`scale(1,-1) translate(0,${0.5*this.ship.particulars.B})`">
      <path
        :d="`M ${scaleXY(-5,15)} C ${scaleXY(0,18)} ${scaleXY(10,21)} ${scaleXY(30,21)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(30,21)} L ${scaleXY(200.5,21)}` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(239.5,0)} C ${scaleXY(239.5,10)} ${scaleXY(220,21)} ${scaleXY(200,21)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(-5,-15)} C ${scaleXY(0,-18)} ${scaleXY(10,-21)} ${scaleXY(30,-21)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(30,-21)} L ${scaleXY(200.5,-21)}` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(239.5,0)} C ${scaleXY(239.5,-10)} ${scaleXY(220,-21)} ${scaleXY(200,-21)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(-5,15)} L ${scaleXY(-5,-15)}` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(8.4,15)} L ${scaleXY(8.4,-15)} L ${scaleXY(37.7,-15)} L ${scaleXY(37.7,15)} Z` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
    </g>

    <g v-if="rotors" :transform="`scale(1,-1) translate(0,${ship.particulars.D+this.ship.particulars.B+this.margin})`">
      <g :transform="`translate(${scaleX(72)},0)`">
          <path 
            v-if="rotors.placement[0][0] || rotors.placement[1][0] || rotors.placement[2][0]"
            :d="`M -${rotors.D},0 L -${rotors.D},${rotors.h} L ${rotors.D},${rotors.h} L ${rotors.D},0` "
            :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"
          />
      </g>
      <g :transform="`translate(${scaleX(104)},0)`">
          <path 
            v-if="rotors.placement[0][1] || rotors.placement[1][1] || rotors.placement[2][1]"
            :d="`M -${rotors.D},0 L -${rotors.D},${rotors.h} L ${rotors.D},${rotors.h} L ${rotors.D},0` "
            :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"
          />
      </g>
      <g :transform="`translate(${scaleX(136)},0)`">
          <path 
            v-if="rotors.placement[0][2] || rotors.placement[1][2] || rotors.placement[2][2]"
            :d="`M -${rotors.D},0 L -${rotors.D},${rotors.h} L ${rotors.D},${rotors.h} L ${rotors.D},0` "
            :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"
          />
      </g>
      <g :transform="`translate(${scaleX(168)},0)`">
          <path 
            v-if="rotors.placement[0][3] || rotors.placement[1][3] || rotors.placement[2][3]"
            :d="`M -${rotors.D},0 L -${rotors.D},${rotors.h} L ${rotors.D},${rotors.h} L ${rotors.D},0` "
            :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"
          />
      </g>
    </g>

    <g v-if="rotors" :transform="`scale(1,-1) translate(0,${0.5*this.ship.particulars.B})`">
      <g :transform="`translate(${scaleX(72)},0)`">
        <g :transform="`translate(0,${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([0,0])"
          />
          <circle v-if="rotors.placement[0][0]" :r="rotors.D/2" v-on:click.stop="toggleRotor([0,0])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,0)`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([1,0])"
          />
          <circle v-if="rotors.placement[1][0]" :r="rotors.D/2" v-on:click.stop="toggleRotor([1,0])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,-${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([2,0])"
          />
          <circle v-if="rotors.placement[2][0]" :r="rotors.D/2" v-on:click.stop="toggleRotor([2,0])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
      </g>
      <g :transform="`translate(${scaleX(104)},0)`">
        <g :transform="`translate(0,${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([0,1])"
          />
          <circle v-if="rotors.placement[0][1]" :r="rotors.D/2" v-on:click.stop="toggleRotor([0,1])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,0)`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([1,1])"
          />
          <circle v-if="rotors.placement[1][1]" :r="rotors.D/2" v-on:click.stop="toggleRotor([1,1])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,-${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([2,1])"
          />
          <circle v-if="rotors.placement[2][1]" :r="rotors.D/2" v-on:click.stop="toggleRotor([2,1])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
      </g>
      <g :transform="`translate(${scaleX(136)},0)`">
        <g :transform="`translate(0,${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([0,2])"
          />
          <circle v-if="rotors.placement[0][2]" :r="rotors.D/2" v-on:click.stop="toggleRotor([0,2])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,0)`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([1,2])"
          />
          <circle v-if="rotors.placement[1][2]" :r="rotors.D/2" v-on:click.stop="toggleRotor([1,2])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,-${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([2,2])"
          />
          <circle v-if="rotors.placement[2][2]" :r="rotors.D/2" v-on:click.stop="toggleRotor([2,2])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
      </g>
      <g :transform="`translate(${scaleX(168)},0)`">
        <g :transform="`translate(0,${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([0,3])"
          />
          <circle v-if="rotors.placement[0][3]" :r="rotors.D/2" v-on:click.stop="toggleRotor([0,3])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,0)`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([1,3])"
          />
          <circle v-if="rotors.placement[1][3]" :r="rotors.D/2" v-on:click.stop="toggleRotor([1,3])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
        <g :transform="`translate(0,-${this.sideRotorDist})`">
          <path 
            :d="`M -${rotors.D},-${rotors.D} L ${rotors.D},-${rotors.D} L ${rotors.D},${rotors.D} L -${rotors.D},${rotors.D} Z` "
            :style="`fill:#ffffff;stroke:#000000;stroke-width:${0.3*lppScale/scale};cursor:pointer;fill-opacity:0.0`"
            v-on:click.stop="toggleRotor([2,3])"
          />
          <circle v-if="rotors.placement[2][3]" :r="rotors.D/2" v-on:click.stop="toggleRotor([2,3])" :style="`fill:#ffffff;stroke:#3b8ede;stroke-width:${lppScale};cursor:pointer;fill-opacity:0.0`"/>
        </g>
      </g>
    </g>
    </g>
  </svg>
</template>

<script>




export default {
  name: "ShipBulk",
  data: function() {
    return {
      Lpp: 233.0,
      Lwl: 238.0,
      Loa: 244.56,
      T: 13.9,
      D: 22.2,
      B: 42.0,
      relMargin: 0.025
    };
  },
  props: {
    ship: Object,
    rotors: Object,
    withRotors: Boolean,
    scale: Number
  },
  methods: {
    scaleXY: function(x, y) {
      return this.scaleX(x) + "," + this.scaleY(y);
    },
    scaleXZ: function(x, z) {
      return this.scaleX(x) + "," + this.scaleZ(z);
    },
    scaleX: function(x) {
      if (x > 0.0 && x < this.Lpp) {
        return (x / this.Lpp) * this.ship.particulars.Lpp;
      } else if (x >= this.Lpp) {
        const Lfwd = this.ship.particulars.Loa - this.ship.particulars.Lwl;
        const refLwfd = this.Loa - this.Lwl;
        return this.ship.particulars.Lpp + ((x - this.Lpp) / refLwfd) * Lfwd;
      } else {
        const Laft = this.ship.particulars.Lwl - this.ship.particulars.Lpp;
        const refLaft = this.Lwl - this.Lpp;
        return (x / refLaft) * Laft;
      }
    },
    scaleY: function(y) {
      return y/this.B*this.ship.particulars.B
    },
    scaleZ: function(z) {
      if (z < this.T) {
        return (z / this.T) * this.ship.particulars.T;
      } else if (z < this.D) {
        return (
          this.ship.particulars.T +
          ((z - this.T) / (this.D - this.T)) *
            (this.ship.particulars.D - this.ship.particulars.T)
        );
      } else {
        return (
          this.ship.particulars.D +
          ((z - this.D) / this.Lpp) * this.ship.particulars.Lpp
        );
      }
    },
    toggleRotor: function(rotor) {
      this.$emit('toggleRotor', rotor)
    }
  },
  computed: {
    lppScale: function() {
      return this.ship.particulars.Lpp / 233.0;
    },
    margin: function() {
      return this.ship.particulars.Loa * this.relMargin
    },
    shipHeight: function() {
      if (!this.rotors) {
        return this.scaleZ(37.091252);
      }
      return Math.max(this.scaleZ(37.091252),this.ship.particulars.D+this.rotors.h)
    },
    bottom: function() {
      return this.shipHeight+2*this.margin+this.ship.particulars.B
    },
    height: function() {
      return this.shipHeight+3*this.margin+this.ship.particulars.B
    },
    width: function() {
      return this.ship.particulars.Loa+2*this.margin
    },
    left: function() {
      return this.ship.particulars.Lpp-this.ship.particulars.Lwl-this.margin
    },
    sideRotorDist: function(){
      return 0.5*this.ship.particulars.B-1.2*this.rotors.D
    }
  },
  // mounted() {
  //   this.$nextTick(function() {
  //     this.onResize(null);
  //       window.addEventListener('resize', this.onResize);
  //   })
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.onResize);
  // }
};
</script>

<style scoped>
/* svg path {
  shape-rendering: optimizeSpeed ;
} */
</style>